import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState, forwardRef } from 'react';
import '../../../shared/css/Input.css';
import { useThemeable } from '../ProviderStyleAccess';
var Input = forwardRef(function (_a, ref) {
    var value = _a.value, placeholder = _a.placeholder, onChange = _a.onChange, onKeyDown = _a.onKeyDown, ariaLabel = _a.ariaLabel, id = _a.id, name = _a.name, _b = _a.numberOfLines, numberOfLines = _b === void 0 ? 1 : _b, _c = _a.maxNumberOfLines, maxNumberOfLines = _c === void 0 ? 4 : _c, _d = _a.multiLine, multiLine = _d === void 0 ? false : _d, _e = _a.type, type = _e === void 0 ? 'text' : _e, className = _a.className, _f = _a.align, align = _f === void 0 ? 'left' : _f;
    var inputRef = useRef(null);
    var _g = useState(value || ''), textareaValue = _g[0], setTextareaValue = _g[1];
    var _h = useThemeable(), size = _h.size, textStyle = _h.textStyle;
    useEffect(function () {
        if (ref) {
            ref.current = inputRef.current;
        }
    }, [ref]);
    var handleTextareaChange = function (event) {
        setTextareaValue(event.target.value);
        if (onChange)
            onChange(event);
    };
    useEffect(function () {
        if (value !== undefined) {
            setTextareaValue(value);
        }
    }, [value]);
    useEffect(function () {
        if (multiLine && inputRef.current) {
            var textarea = inputRef.current;
            var lineHeight = textStyle.bodyLineHeight;
            // Reset height to auto to get accurate scrollHeight
            textarea.style.height = 'auto';
            // Calculate the minimum height based on numberOfLines
            var minHeight = numberOfLines * lineHeight;
            // Calculate the maximum height based on maxNumberOfLines
            var maxHeight = maxNumberOfLines * lineHeight;
            // Set the minHeight and maxHeight
            textarea.style.minHeight = "".concat(minHeight, "px");
            textarea.style.maxHeight = "".concat(maxHeight, "px");
            // Set the height to the scrollHeight, but it will be constrained by maxHeight
            textarea.style.height = "".concat(textarea.scrollHeight, "px");
            // Ensure overflow-y is set to auto to allow scrolling
            textarea.style.overflowY = 'auto';
        }
    }, [textareaValue, multiLine, numberOfLines, maxNumberOfLines, textStyle.bodyLineHeight]);
    var focusInput = function () {
        if (multiLine) {
            if (inputRef.current) {
                var textarea = inputRef.current;
                textarea.focus();
            }
        }
        else {
            if (inputRef.current) {
                var input = inputRef.current;
                input.focus();
            }
        }
    };
    return (_jsx("div", { className: "".concat(!multiLine ? 'input' : 'input', "-wrapper width-fill ").concat(className || ''), onClick: focusInput, children: multiLine ? (_jsx("textarea", { ref: inputRef, className: "textarea ".concat(className || '', " ").concat(align), value: textareaValue, placeholder: placeholder, onChange: handleTextareaChange, onKeyDown: onKeyDown, "aria-label": ariaLabel || placeholder, id: id, name: name, rows: numberOfLines, style: {
                minHeight: "".concat(numberOfLines * textStyle.bodyLineHeight, "px"),
                maxHeight: "".concat(maxNumberOfLines * textStyle.bodyLineHeight, "px"),
                overflowY: 'auto', // Ensure scrolling is enabled
            } })) : (_jsx("input", { ref: inputRef, className: "input ".concat(className || '', " ").concat(align), type: type, value: value, placeholder: placeholder, onChange: onChange, onKeyDown: onKeyDown, "aria-label": ariaLabel || placeholder, id: id, name: name })) }));
});
Input.displayName = 'Input';
export { Input };
